import ProductHero from "./ProductHero";
import ProductValues from "./ProductValues";
import ProductSmokingHero from "./ProductSmokinghero";
import ProductCTA from "./ProductCTA";
export default function HomePage(){
return(
    <>
<ProductHero/>
<ProductValues/>
<ProductCTA/>
<ProductSmokingHero/>
</>
)
}